<template>
  <div ref="map" class="map"></div>
</template>

<script>
import { markRaw } from 'vue';
import Basemap from '../lib/Basemap';
export default {
  mounted() {
    this.mymap = markRaw(new Basemap(this.$refs.map));
  },
  unmounted() {
    this.mymap.map.remove();
  },
  data() {
    return {
      mymap: markRaw({}),
    }
  },
}
</script>